import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import { PDLButton, PDLTypography } from "../../../dna";
import Row from "react-bootstrap/Row";
import "./index.scss";

const HomeNewsletter = () => (
  <Container className="pdl_component_home_newsletter">
    <Row>
      <Col xs={12} sm={6} lg={4} className="mx-auto">
        <Form>
          <Row>
            <Col className="text-center mb-5">
              <PDLTypography as="h2" display size="md" weight="semibold">
                Assine a nossa newsletter
              </PDLTypography>
            </Col>
          </Row>
          <Row className="d-flex flex-row flex-nowrap align-items-center pb-1">
            <Col className="ps-0">
              <Form.Control placeholder="Insira seu e-mail" />
            </Col>
            <Col className="pe-0 col-sm-auto">
              <PDLButton type="button" variant="primary">
                Assinar Newsletter
              </PDLButton>
            </Col>
          </Row>
          <Row>
            <Col className="ps-0">
              <PDLTypography size="sm">
                Nós cuidamos dos seus dados na nossa{" "}
                <a href="#">política de privacidade</a>.
              </PDLTypography>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  </Container>
);

export default HomeNewsletter;
